/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AddExternalExaminerRequest } from '../models';
import { AppointEeRequestFormRequest } from '../models';
import { AppointExternalExaminerRequest } from '../models';
import { ApprovalEeRequestFormRequest } from '../models';
import { BooleanResponse } from '../models';
import { EeRequestFormIEnumerableResponse } from '../models';
import { EeRequestFormResponse } from '../models';
import { EeRequestFormSummaryRequest } from '../models';
import { EeSignUpFormIEnumerableResponse } from '../models';
import { EeSignUpFormRequest } from '../models';
import { EeSignUpFormResponse } from '../models';
import { ExternalExaminerForEEResponse } from '../models';
import { ExternalExaminerForIndividualPracticeResponse } from '../models';
import { ExternalExaminerResponse } from '../models';
import { ExternalExaminerSummaryRequest } from '../models';
import { ExternalExaminerSummaryTaIEnumerableResponse } from '../models';
import { SearchExternalExaminerIEnumerableResponse } from '../models';
import { SearchExternalExaminerRequest } from '../models';
import { TerminateEeRequestFormRequest } from '../models';
import { UpdateExternalExaminerForEeRequest } from '../models';
import { UpdateExternalExaminerRequest } from '../models';
/**
 * ExternalExaminerApi - axios parameter creator
 * @export
 */
export const ExternalExaminerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Add External Examiner
         * @param {AddExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminAddExternalExaminerPost: async (body?: AddExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/AddExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Appoint External Examiner
         * @param {AppointExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminAppointExternalExaminerPost: async (body?: AppointExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/AppointExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Approve External Examiner Request Form
         * @param {ApprovalEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminApproveEeRequestFormPost: async (body?: ApprovalEeRequestFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/ApproveEeRequestForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Approve External Examiner Sign Up Form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut: async (eeSignUpFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeSignUpFormId' is not null or undefined
            if (eeSignUpFormId === null || eeSignUpFormId === undefined) {
                throw new RequiredError('eeSignUpFormId','Required parameter eeSignUpFormId was null or undefined when calling apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut.');
            }
            const localVarPath = `/api/v2/ExternalExaminer/Admin/ApproveEeSignUpForm/{eeSignUpFormId}`
                .replace(`{${"eeSignUpFormId"}}`, encodeURIComponent(String(eeSignUpFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Request Form
         * @param {number} eeRequestFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet: async (eeRequestFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeRequestFormId' is not null or undefined
            if (eeRequestFormId === null || eeRequestFormId === undefined) {
                throw new RequiredError('eeRequestFormId','Required parameter eeRequestFormId was null or undefined when calling apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet.');
            }
            const localVarPath = `/api/v2/ExternalExaminer/Admin/GetEeRequestFormById/{eeRequestFormId}`
                .replace(`{${"eeRequestFormId"}}`, encodeURIComponent(String(eeRequestFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Request Form
         * @param {EeRequestFormSummaryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeRequestFormsPost: async (body?: EeRequestFormSummaryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/GetEeRequestForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Sign Up Form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet: async (eeSignUpFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeSignUpFormId' is not null or undefined
            if (eeSignUpFormId === null || eeSignUpFormId === undefined) {
                throw new RequiredError('eeSignUpFormId','Required parameter eeSignUpFormId was null or undefined when calling apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet.');
            }
            const localVarPath = `/api/v2/ExternalExaminer/Admin/GetEeSignUpFormById/{eeSignUpFormId}`
                .replace(`{${"eeSignUpFormId"}}`, encodeURIComponent(String(eeSignUpFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Sign Up Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeSignUpFormGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/GetEeSignUpForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner
         * @param {number} externalExaminerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet: async (externalExaminerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalExaminerId' is not null or undefined
            if (externalExaminerId === null || externalExaminerId === undefined) {
                throw new RequiredError('externalExaminerId','Required parameter externalExaminerId was null or undefined when calling apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet.');
            }
            const localVarPath = `/api/v2/ExternalExaminer/Admin/GetExternalExaminerById/{externalExaminerId}`
                .replace(`{${"externalExaminerId"}}`, encodeURIComponent(String(externalExaminerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiners
         * @param {ExternalExaminerSummaryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetExternalExaminersPost: async (body?: ExternalExaminerSummaryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/GetExternalExaminers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Reject External Examiner Request Form
         * @param {ApprovalEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminRejectEeRequestFormPost: async (body?: ApprovalEeRequestFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/RejectEeRequestForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Reject External Examiner Sign Up form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut: async (eeSignUpFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeSignUpFormId' is not null or undefined
            if (eeSignUpFormId === null || eeSignUpFormId === undefined) {
                throw new RequiredError('eeSignUpFormId','Required parameter eeSignUpFormId was null or undefined when calling apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut.');
            }
            const localVarPath = `/api/v2/ExternalExaminer/Admin/RejectEeSignUpForm/{eeSignUpFormId}`
                .replace(`{${"eeSignUpFormId"}}`, encodeURIComponent(String(eeSignUpFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiners
         * @param {SearchExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminSearchExternalExaminersPost: async (body?: SearchExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/SearchExternalExaminers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Update External Examiner
         * @param {UpdateExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminUpdateExternalExaminerPost: async (body?: UpdateExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/Admin/UpdateExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Appoint External Examiner Request Form
         * @param {AppointEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAppointEeRequestFormPost: async (body?: AppointEeRequestFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/AppointEeRequestForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ToBeExternalExaminer | Returns External Examiner Sign Up Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerGetEeSignUpFormGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/GetEeSignUpForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Returns External Examiner Details
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet: async (individualPracticeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'individualPracticeId' is not null or undefined
            if (individualPracticeId === null || individualPracticeId === undefined) {
                throw new RequiredError('individualPracticeId','Required parameter individualPracticeId was null or undefined when calling apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet.');
            }
            const localVarPath = `/api/v2/ExternalExaminer/GetExternalExaminerByIndividualPracticeId/{individualPracticeId}`
                .replace(`{${"individualPracticeId"}}`, encodeURIComponent(String(individualPracticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns External Examiner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerGetExternalExaminerDetailsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/GetExternalExaminerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ToBeExternalExaminer | Save External Examiner Sign Up form
         * @param {EeSignUpFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerSaveEeSignUpFormPost: async (body?: EeSignUpFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/SaveEeSignUpForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Returns External Examiners
         * @param {SearchExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerSearchExternalExaminersPost: async (body?: SearchExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/SearchExternalExaminers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Terminate External Examiner Request Form
         * @param {TerminateEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerTerminateEeRequestFormPost: async (body?: TerminateEeRequestFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/TerminateEeRequestForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Update External Examiner Details
         * @param {UpdateExternalExaminerForEeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerUpdateExternalExaminerDetailsPost: async (body?: UpdateExternalExaminerForEeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ExternalExaminer/UpdateExternalExaminerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalExaminerApi - functional programming interface
 * @export
 */
export const ExternalExaminerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Add External Examiner
         * @param {AddExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminAddExternalExaminerPost(body?: AddExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminAddExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Appoint External Examiner
         * @param {AppointExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminAppointExternalExaminerPost(body?: AppointExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminAppointExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Approve External Examiner Request Form
         * @param {ApprovalEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminApproveEeRequestFormPost(body?: ApprovalEeRequestFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminApproveEeRequestFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Approve External Examiner Sign Up Form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Request Form
         * @param {number} eeRequestFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet(eeRequestFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeRequestFormResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet(eeRequestFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Request Form
         * @param {EeRequestFormSummaryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminGetEeRequestFormsPost(body?: EeRequestFormSummaryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeRequestFormIEnumerableResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminGetEeRequestFormsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Sign Up Form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(eeSignUpFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeSignUpFormResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(eeSignUpFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Sign Up Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminGetEeSignUpFormGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeSignUpFormIEnumerableResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminGetEeSignUpFormGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner
         * @param {number} externalExaminerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(externalExaminerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalExaminerResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(externalExaminerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiners
         * @param {ExternalExaminerSummaryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminGetExternalExaminersPost(body?: ExternalExaminerSummaryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalExaminerSummaryTaIEnumerableResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminGetExternalExaminersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Reject External Examiner Request Form
         * @param {ApprovalEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminRejectEeRequestFormPost(body?: ApprovalEeRequestFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminRejectEeRequestFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Reject External Examiner Sign Up form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns External Examiners
         * @param {SearchExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminSearchExternalExaminersPost(body?: SearchExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchExternalExaminerIEnumerableResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminSearchExternalExaminersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Update External Examiner
         * @param {UpdateExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAdminUpdateExternalExaminerPost(body?: UpdateExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAdminUpdateExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Appoint External Examiner Request Form
         * @param {AppointEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerAppointEeRequestFormPost(body?: AppointEeRequestFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerAppointEeRequestFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ToBeExternalExaminer | Returns External Examiner Sign Up Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerGetEeSignUpFormGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeSignUpFormResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerGetEeSignUpFormGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Returns External Examiner Details
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet(individualPracticeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalExaminerForIndividualPracticeResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet(individualPracticeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns External Examiner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerGetExternalExaminerDetailsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalExaminerForEEResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerGetExternalExaminerDetailsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ToBeExternalExaminer | Save External Examiner Sign Up form
         * @param {EeSignUpFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerSaveEeSignUpFormPost(body?: EeSignUpFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerSaveEeSignUpFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Returns External Examiners
         * @param {SearchExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerSearchExternalExaminersPost(body?: SearchExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchExternalExaminerIEnumerableResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerSearchExternalExaminersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Terminate External Examiner Request Form
         * @param {TerminateEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerTerminateEeRequestFormPost(body?: TerminateEeRequestFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerTerminateEeRequestFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Update External Examiner Details
         * @param {UpdateExternalExaminerForEeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(body?: UpdateExternalExaminerForEeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ExternalExaminerApiAxiosParamCreator(configuration).apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalExaminerApi - factory interface
 * @export
 */
export const ExternalExaminerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAll | Add External Examiner
         * @param {AddExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminAddExternalExaminerPost(body?: AddExternalExaminerRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminAddExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Appoint External Examiner
         * @param {AppointExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminAppointExternalExaminerPost(body?: AppointExternalExaminerRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminAppointExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Approve External Examiner Request Form
         * @param {ApprovalEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminApproveEeRequestFormPost(body?: ApprovalEeRequestFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminApproveEeRequestFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Approve External Examiner Sign Up Form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId: number, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Request Form
         * @param {number} eeRequestFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet(eeRequestFormId: number, options?: any): AxiosPromise<EeRequestFormResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet(eeRequestFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Request Form
         * @param {EeRequestFormSummaryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeRequestFormsPost(body?: EeRequestFormSummaryRequest, options?: any): AxiosPromise<EeRequestFormIEnumerableResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminGetEeRequestFormsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Sign Up Form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(eeSignUpFormId: number, options?: any): AxiosPromise<EeSignUpFormResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(eeSignUpFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner Sign Up Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetEeSignUpFormGet(options?: any): AxiosPromise<EeSignUpFormIEnumerableResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminGetEeSignUpFormGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiner
         * @param {number} externalExaminerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(externalExaminerId: number, options?: any): AxiosPromise<ExternalExaminerResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(externalExaminerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiners
         * @param {ExternalExaminerSummaryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminGetExternalExaminersPost(body?: ExternalExaminerSummaryRequest, options?: any): AxiosPromise<ExternalExaminerSummaryTaIEnumerableResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminGetExternalExaminersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Reject External Examiner Request Form
         * @param {ApprovalEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminRejectEeRequestFormPost(body?: ApprovalEeRequestFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminRejectEeRequestFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Reject External Examiner Sign Up form
         * @param {number} eeSignUpFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId: number, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns External Examiners
         * @param {SearchExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminSearchExternalExaminersPost(body?: SearchExternalExaminerRequest, options?: any): AxiosPromise<SearchExternalExaminerIEnumerableResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminSearchExternalExaminersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Update External Examiner
         * @param {UpdateExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAdminUpdateExternalExaminerPost(body?: UpdateExternalExaminerRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAdminUpdateExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Appoint External Examiner Request Form
         * @param {AppointEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerAppointEeRequestFormPost(body?: AppointEeRequestFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerAppointEeRequestFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ToBeExternalExaminer | Returns External Examiner Sign Up Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerGetEeSignUpFormGet(options?: any): AxiosPromise<EeSignUpFormResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerGetEeSignUpFormGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Returns External Examiner Details
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet(individualPracticeId: number, options?: any): AxiosPromise<ExternalExaminerForIndividualPracticeResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet(individualPracticeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns External Examiner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerGetExternalExaminerDetailsGet(options?: any): AxiosPromise<ExternalExaminerForEEResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerGetExternalExaminerDetailsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ToBeExternalExaminer | Save External Examiner Sign Up form
         * @param {EeSignUpFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerSaveEeSignUpFormPost(body?: EeSignUpFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerSaveEeSignUpFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Returns External Examiners
         * @param {SearchExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerSearchExternalExaminersPost(body?: SearchExternalExaminerRequest, options?: any): AxiosPromise<SearchExternalExaminerIEnumerableResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerSearchExternalExaminersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustCoordinator | Terminate External Examiner Request Form
         * @param {TerminateEeRequestFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerTerminateEeRequestFormPost(body?: TerminateEeRequestFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerTerminateEeRequestFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Update External Examiner Details
         * @param {UpdateExternalExaminerForEeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(body?: UpdateExternalExaminerForEeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ExternalExaminerApiFp(configuration).apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalExaminerApi - object-oriented interface
 * @export
 * @class ExternalExaminerApi
 * @extends {BaseAPI}
 */
export class ExternalExaminerApi extends BaseAPI {
    /**
     * 
     * @summary TaAll | Add External Examiner
     * @param {AddExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminAddExternalExaminerPost(body?: AddExternalExaminerRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminAddExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Appoint External Examiner
     * @param {AppointExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminAppointExternalExaminerPost(body?: AppointExternalExaminerRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminAppointExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Approve External Examiner Request Form
     * @param {ApprovalEeRequestFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminApproveEeRequestFormPost(body?: ApprovalEeRequestFormRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminApproveEeRequestFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Approve External Examiner Sign Up Form
     * @param {number} eeSignUpFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId: number, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner Request Form
     * @param {number} eeRequestFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet(eeRequestFormId: number, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminGetEeRequestFormByIdEeRequestFormIdGet(eeRequestFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner Request Form
     * @param {EeRequestFormSummaryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminGetEeRequestFormsPost(body?: EeRequestFormSummaryRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminGetEeRequestFormsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner Sign Up Form
     * @param {number} eeSignUpFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(eeSignUpFormId: number, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(eeSignUpFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner Sign Up Forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminGetEeSignUpFormGet(options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminGetEeSignUpFormGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiner
     * @param {number} externalExaminerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(externalExaminerId: number, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(externalExaminerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiners
     * @param {ExternalExaminerSummaryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminGetExternalExaminersPost(body?: ExternalExaminerSummaryRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminGetExternalExaminersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Reject External Examiner Request Form
     * @param {ApprovalEeRequestFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminRejectEeRequestFormPost(body?: ApprovalEeRequestFormRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminRejectEeRequestFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Reject External Examiner Sign Up form
     * @param {number} eeSignUpFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId: number, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(eeSignUpFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns External Examiners
     * @param {SearchExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminSearchExternalExaminersPost(body?: SearchExternalExaminerRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminSearchExternalExaminersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Update External Examiner
     * @param {UpdateExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAdminUpdateExternalExaminerPost(body?: UpdateExternalExaminerRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAdminUpdateExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustCoordinator | Appoint External Examiner Request Form
     * @param {AppointEeRequestFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerAppointEeRequestFormPost(body?: AppointEeRequestFormRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerAppointEeRequestFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary ToBeExternalExaminer | Returns External Examiner Sign Up Form
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerGetEeSignUpFormGet(options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerGetEeSignUpFormGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustCoordinator | Returns External Examiner Details
     * @param {number} individualPracticeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet(individualPracticeId: number, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerGetExternalExaminerByIndividualPracticeIdIndividualPracticeIdGet(individualPracticeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns External Examiner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerGetExternalExaminerDetailsGet(options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerGetExternalExaminerDetailsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary ToBeExternalExaminer | Save External Examiner Sign Up form
     * @param {EeSignUpFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerSaveEeSignUpFormPost(body?: EeSignUpFormRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerSaveEeSignUpFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustCoordinator | Returns External Examiners
     * @param {SearchExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerSearchExternalExaminersPost(body?: SearchExternalExaminerRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerSearchExternalExaminersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustCoordinator | Terminate External Examiner Request Form
     * @param {TerminateEeRequestFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerTerminateEeRequestFormPost(body?: TerminateEeRequestFormRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerTerminateEeRequestFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Update External Examiner Details
     * @param {UpdateExternalExaminerForEeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalExaminerApi
     */
    public apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(body?: UpdateExternalExaminerForEeRequest, options?: any) {
        return ExternalExaminerApiFp(this.configuration).apiV2ExternalExaminerUpdateExternalExaminerDetailsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
